
























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';

import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';

import { ICustomerActivityTableRow } from '@/models/performance';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    FilterTag,
    TableCard,
    EmptyStateTable
  }
})
export default class ActivitiesList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() activities!: ICustomerActivityTableRow[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  detail(rowData: Record<string, any>) {
    this.$emit('item-click', rowData);
    this.$router.push(`/performance/customer-center/${rowData.customer.id}`);
  }
}
